// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/surveillance-information-and-visual-separation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/surveillance-information-and-visual-separation/surveillance-information-and-visual-separation.js';

mount([g0]);
